import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=412bf2e0&"
import script from "./TextWidget.vue?vue&type=script&lang=js&"
export * from "./TextWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/daum/program/jenkins/workspace/cafe-mobile-web/cafe-mobile-web-production/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('412bf2e0')) {
      api.createRecord('412bf2e0', component.options)
    } else {
      api.reload('412bf2e0', component.options)
    }
    module.hot.accept("./TextWidget.vue?vue&type=template&id=412bf2e0&", function () {
      api.rerender('412bf2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/article_widget/components/TextWidget.vue"
export default component.exports